import React from "react";
import { motion } from "framer-motion";

export default function Projets() {
  const projets = [
    {
      image:
        "https://images.unsplash.com/photo-1581090700227-1e37b190418e?auto=format&fit=crop&w=800&q=80",
      titre: "Déploiement d’un réseau sécurisé pour une PME",
      description:
        "Conception et installation d’une infrastructure réseau complète incluant le câblage, la configuration des routeurs et la mise en place d’un pare-feu professionnel.",
    },
    {
      image:
        "https://images.unsplash.com/photo-1556155092-490a1ba16284?auto=format&fit=crop&w=800&q=80",
      titre: "Mise en place d’une solution de téléphonie IP",
      description:
        "Déploiement d’un système VoIP interconnecté entre plusieurs agences, permettant une communication fluide et économique.",
    },
    {
      image:
        "https://i0.wp.com/www.abime-concept.com/wp-content/uploads/2017/03/solution-web.jpg?fit=1000%2C585&ssl=1",
      titre: "Création d’une application web sur mesure",
      description:
        "Développement d’une application web professionnelle pour la gestion interne d’une entreprise, avec authentification et tableau de bord dynamique.",
    },
  ];

  // Animation container (effet cascade plus lent)
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.45, // délai plus long entre chaque carte
      },
    },
  };

  // Animation de chaque carte (transition plus douce)
  const card = {
    hidden: { opacity: 0, y: 50 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeOut" }, // durée augmentée
    },
  };

  return (
    <motion.section
      id="projets"
      className="py-20 bg-white px-6 md:px-16"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={container}
    >
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-primary mb-4">Nos Projets</h2>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Découvrez quelques exemples de réalisations et de solutions déployées par
          Virtuo Systems Maroc pour ses clients.
        </p>
      </div>

      <motion.div
        className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl mx-auto"
        variants={container}
      >
        {projets.map((projet, index) => (
          <motion.div
            key={index}
            variants={card}
            whileHover={{
              scale: 1.03,
              boxShadow: "0px 15px 25px rgba(0,0,0,0.1)",
            }}
            transition={{ type: "spring", stiffness: 200 }}
            className="bg-gray-50 rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition transform hover:-translate-y-2"
          >
            <img
              src={projet.image}
              alt={projet.titre}
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-dark mb-2">
                {projet.titre}
              </h3>
              <p className="text-gray-600 text-sm">{projet.description}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </motion.section>
  );
}
